import api from "@/lib/api";

let cached = null;
let pending = null;

export function getShopStatus() {
  if (cached) return Promise.resolve(cached);
  if (pending) return pending;
  pending = api
    .get("/shop/status")
    .then((res) => {
      cached = res.data;
      return cached;
    })
    .catch(() => ({ enabled: false, hidden: false }))
    .finally(() => {
      pending = null;
    });
  return pending;
}

export function refreshShopStatus() {
  cached = null;
  return getShopStatus();
}

// Preview token (owner access while the boutique is closed) — session only
export function getPreviewToken() {
  return sessionStorage.getItem("cfm_shop_preview") || "";
}

export function setPreviewToken(token) {
  if (token) sessionStorage.setItem("cfm_shop_preview", token);
  else sessionStorage.removeItem("cfm_shop_preview");
}

export const AVAIL_STYLE = {
  in_stock: "bg-bamboo-soft text-bamboo-deep",
  on_order: "bg-amber-100 text-amber-800",
  unavailable: "bg-rose-100 text-rose-700",
};

// "Έως 5 εργάσιμες" / "Within 5 business days" (badge, short)
export const leadText = (lang, n) => {
  if (n == null) return "";
  if (lang === "el") return n === 1 ? "Έως 1 εργάσιμη" : `Έως ${n} εργάσιμες`;
  return n === 1 ? "Within 1 business day" : `Within ${n} business days`;
};

// "3 Χρώματα" / "3 Colours" — badge on product image (top right), dev-toggleable
export const ColorCountBadge = ({ count, lang }) => {
  if (!count || count < 1) return null;
  const txt = lang === "el" ? `${count} ${count === 1 ? "Χρώμα" : "Χρώματα"}` : `${count} ${count === 1 ? "Colour" : "Colours"}`;
  return (
    <span className="absolute top-2.5 right-2.5 z-10 rounded-full bg-white/90 backdrop-blur-sm border border-brand/15 text-brand-ink text-[11px] font-bold px-2.5 py-1 shadow-sm" data-testid="color-count-badge">
      {txt}
    </span>
  );
};

// Full sentence for the product page
export const leadTextFull = (lang, n) => {
  if (n == null) return "";
  if (lang === "el") {
    return n === 1
      ? "Έως 1 εργάσιμη ημέρα αφού ολοκληρώσεις την παραγγελία σου"
      : `Έως ${n} εργάσιμες ημέρες αφού ολοκληρώσεις την παραγγελία σου`;
  }
  return n === 1 ? "Ready within 1 business day of placing your order" : `Ready within ${n} business days of placing your order`;
};
// Effective selling price of a variant (offer wins, then variant override, then base)
export const variantPrice = (product, variant) =>
  variant?.sale_price != null ? Number(variant.sale_price)
    : variant?.price != null ? Number(variant.price)
      : Number(product?.price ?? 0);

// Price before the offer (variant override or base)
export const variantOriginalPrice = (product, variant) =>
  variant?.price != null ? Number(variant.price) : Number(product?.price ?? 0);

export const formatOrigRange = (p) => {
  const min = Number(p.orig_min ?? p.price ?? 0);
  const max = Number(p.orig_max ?? p.price ?? 0);
  return min === max ? `€${min.toFixed(2)}` : `€${min.toFixed(2)}–€${max.toFixed(2)}`;
};

// "€10.00" or "€10.00–€15.00" when variants differ
export const formatPriceRange = (p) => {
  const min = Number(p.price_min ?? p.price ?? 0);
  const max = Number(p.price_max ?? p.price ?? 0);
  return min === max ? `€${min.toFixed(2)}` : `€${min.toFixed(2)}–€${max.toFixed(2)}`;
};
